/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonsmissinginstagram3Inputs */

const en_listingbuttonsmissinginstagram3 = /** @type {(inputs: Listingbuttonsmissinginstagram3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Instagram –`)
};

const de_listingbuttonsmissinginstagram3 = /** @type {(inputs: Listingbuttonsmissinginstagram3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Instagram –`)
};

/**
* | output |
* | --- |
* | "No Instagram –" |
*
* @param {Listingbuttonsmissinginstagram3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsmissinginstagram3 = /** @type {((inputs?: Listingbuttonsmissinginstagram3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsmissinginstagram3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsmissinginstagram3(inputs)
	return de_listingbuttonsmissinginstagram3(inputs)
});
export { listingbuttonsmissinginstagram3 as "listingButtonsMissingInstagram" }